import { jsx as p } from "react/jsx-runtime";
import { c as N } from "../index-Cu0xwYjD.js";
import * as l from "react";
import { fontSizeToClassName as c, fontColorToClassName as d, textAlignToClassName as v, fontWeightToClassName as C } from "./Props.js";
const g = {
  h1: "v-h1",
  h2: "v-h2",
  h3: "v-h3",
  h4: "v-h4",
  h5: "v-h5",
  h6: "v-h6"
}, T = l.forwardRef(
  ({
    children: h,
    className: o,
    styleAs: r,
    node: a,
    size: s,
    color: e,
    align: t,
    weight: m,
    ...n
  }, f) => {
    const i = x(a);
    return /* @__PURE__ */ p(
      i,
      {
        ref: f,
        ...n,
        className: N(
          o,
          g[r ?? a ?? "h1"],
          s && c[s],
          e && d[e],
          t && v[t],
          m && C[m]
        ),
        children: h
      }
    );
  }
), x = (h) => ({
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6"
})[h ?? "h1"];
T.displayName = "Heading";
export {
  T as Heading
};
